import { Modal } from '@heroui/react';
import PropTypes from 'prop-types';

const CustomModal = ({ 
  children, 
  handleClose = () => {}, 
  maxHeight = "85vh",
  show = false, 
  ...props 
}) => (
  <Modal
    isOpen={show}
    onClose={() => handleClose()}
    placement="center"
    isDismissable={false}
    isKeyboardDismissDisabled={true}
    scrollBehavior="inside"
    radius="lg"
    className={`max-h-[${maxHeight}]`}
    classNames={{
      backdrop: "z-[99] bg-overlay/75",
      header: "bg-indigo-800 rounded-t-xl text-white",
      wrapper: "md:items-center z-[100]",
      closeButton: "hover:bg-white/5 text-white mt-2 mr-2",
    }}
    {...props}
  >
    {children}
  </Modal>
)

CustomModal.propTypes = {
  children: PropTypes.node.isRequired,
  handleClose: PropTypes.func,
  maxHeight: PropTypes.string,
  show: PropTypes.bool,
}

export default CustomModal